import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function CampaignAccessDeniedPage() {
  const navigate = useNavigate();
  const userEmail = localStorage.getItem('authEmail');

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: 'linear-gradient(145deg, #f8fafc 0%, #ecf2f9 100%)',
        padding: '20px',
      }}
    >
      <div
        style={{
          width: 'min(560px, 94vw)',
          background: '#fff',
          border: '1px solid #dbe6f3',
          borderRadius: '18px',
          boxShadow: '0 18px 42px rgba(21, 34, 56, 0.14)',
          padding: '28px',
          textAlign: 'center',
        }}
      >
        <h1 style={{ margin: 0, fontSize: '28px', color: '#1f2937' }}>Доступ ограничен</h1>
        <p style={{ margin: '12px 0 0', fontSize: '16px', color: '#4b5563', lineHeight: 1.5 }}>
          Эта кампания закрыта для вашего аккаунта.
        </p>
        <p style={{ margin: '8px 0 0', fontSize: '14px', color: '#6b7280', lineHeight: 1.5 }}>
          {userEmail
            ? `Вы вошли как ${userEmail}. Попросите владельца кампании добавить этот email в список доступа.`
            : 'Попросите владельца кампании выдать вам доступ.'}
        </p>

        <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={() => navigate('/campaigns')}
            style={{
              border: '1px solid #d0dae8',
              borderRadius: '10px',
              background: '#fff',
              color: '#1f2937',
              padding: '10px 14px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            К моим кампаниям
          </button>
          <button
            type="button"
            onClick={() => {
              localStorage.removeItem('authToken');
              localStorage.removeItem('authEmail');
              navigate('/auth', { replace: true });
            }}
            style={{
              border: 'none',
              borderRadius: '10px',
              background: '#1d4ed8',
              color: '#fff',
              padding: '10px 14px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Сменить аккаунт
          </button>
        </div>
      </div>
    </div>
  );
}
